/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionSizeDiagnostics
 */
export interface SubmissionSizeDiagnostics {
    /**
     * 
     */
    lengthMm?: number | null;
    /**
     * 
     */
    girthMm?: number | null;
    /**
     * 
     */
    confidence?: string | null;
    /**
     * 
     */
    lowReason?: string | null;
    /**
     * 
     */
    members?: Array<string>;
    /**
     * 
     */
    weightBandG?: Array<number> | null;
}

/**
 * Check if a given object implements the SubmissionSizeDiagnostics interface.
 */
export function instanceOfSubmissionSizeDiagnostics(value: object): value is SubmissionSizeDiagnostics {
    return true;
}

export function SubmissionSizeDiagnosticsFromJSON(json: any): SubmissionSizeDiagnostics {
    return SubmissionSizeDiagnosticsFromJSONTyped(json, false);
}

export function SubmissionSizeDiagnosticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionSizeDiagnostics {
    if (json == null) {
        return json;
    }
    return {
        
        'lengthMm': json['length_mm'] === undefined ? undefined : json['length_mm'] === null ? null : json['length_mm'],
        'girthMm': json['girth_mm'] === undefined ? undefined : json['girth_mm'] === null ? null : json['girth_mm'],
        'confidence': json['confidence'] === undefined ? undefined : json['confidence'] === null ? null : json['confidence'],
        'lowReason': json['low_reason'] === undefined ? undefined : json['low_reason'] === null ? null : json['low_reason'],
        'members': json['members'] == null ? undefined : json['members'],
        'weightBandG': json['weight_band_g'] === undefined ? undefined : json['weight_band_g'] === null ? null : json['weight_band_g'],
    };
}

export function SubmissionSizeDiagnosticsToJSON(json: any): SubmissionSizeDiagnostics {
    return SubmissionSizeDiagnosticsToJSONTyped(json, false);
}

export function SubmissionSizeDiagnosticsToJSONTyped(value?: SubmissionSizeDiagnostics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'confidence': value['confidence'],
        'low_reason': value['lowReason'],
        'members': value['members'],
        'weight_band_g': value['weightBandG'],
    };
}

